import React, { useCallback, useState } from 'react';
import { useDataProvider, useNotify, useRecordContext, useRedirect } from 'react-admin';
import { Button } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { buildCloneState } from './list/duplicateDates';

// O <Button> do react-admin vira só ícone abaixo de 600 px (e sem ícone fica um círculo vazio): aqui o botão do Show é do MUI,
// com o texto sempre à mostra e a altura mínima de toque.
export const showActionSx = { minHeight: 40, px: 2, textTransform: 'none', fontSize: 14, fontWeight: 500 } as const;
// "Duplicar" em tom neutro (o verde da marca sobre branco não passa no contraste).
const neutralActionSx = { ...showActionSx, color: '#1e293b', borderColor: '#7c8595', '&:hover': { bgcolor: '#f1f5f9', borderColor: '#7c8595' } } as const;

interface CloneDiscountButtonProp {
  record?: any;
  variant?: 'text' | 'outlined' | 'contained';
  style?: any;
}

/**
 * Duplicar: busca o desconto inteiro (GET /discounts/{id}) e abre o cadastro com ele preenchido,
 * pelo state do router. `overrides` troca o período ("Duplicar com novas datas").
 * Dá `false` quando falha, para a tela de origem decidir se mantém o diálogo aberto.
 */
export const useDuplicateDiscount = () => {
  const dataProvider = useDataProvider();
  const redirect = useRedirect();
  const notify = useNotify();
  const [busyId, setBusyId] = useState<string | null>(null);

  const duplicate = useCallback(async (id: string, overrides?: { startAt?: string; endAt?: string }): Promise<boolean> => {
    setBusyId(id);
    try {
      const { data } = await dataProvider.getOne('discounts', { id });
      redirect('/discounts/create', undefined, undefined, undefined, buildCloneState(data, overrides));
      return true;
    } catch {
      notify('Não foi possível realizar a operação, tente novamente', { type: 'warning' });
      setBusyId(null);
      return false;
    }
  }, [dataProvider, redirect, notify]);

  return { duplicate, busyId };
};

const CloneDiscountButton: React.FC<CloneDiscountButtonProp> = () => {
  const record = useRecordContext();
  const { duplicate, busyId } = useDuplicateDiscount();
  if (!record) { return null; }

  return (
    <Button
      onClick={(event: React.MouseEvent) => { event.stopPropagation(); duplicate(String(record.id)); }}
      variant="outlined"
      startIcon={<ContentCopyIcon />}
      disabled={busyId === record.id}
      sx={neutralActionSx}
    >
      Duplicar
    </Button>
  );
}

export default CloneDiscountButton;
